import {testIdProps} from '@github-ui/test-id-props'
import {ActionList} from '@primer/react'

import {SanitizedHtml} from './dom/sanitized-html'

export interface SuggestionsListItemProps {
  renderItem?: () => React.ReactElement
  value: string
  asHTML: boolean
  selected: boolean
  onSelect: () => void
  selectedItemRef: React.RefObject<HTMLLIElement | null> | null
  testId: string
  id: string
}

export const SuggestionsListItem: React.FC<SuggestionsListItemProps> = ({
  selectedItemRef,
  onSelect,
  id,
  selected,
  testId,
  renderItem,
  asHTML,
  value,
}: SuggestionsListItemProps) => {
  const computedProps = {
    ref: selectedItemRef,
    onSelect,
    id,
    'aria-selected': selected,
    active: selected,
    tabIndex: -1,
    ...testIdProps(testId),
  }

  if (renderItem) {
    return (
      <ActionList.Item role="option" {...computedProps}>
        {renderItem()}
      </ActionList.Item>
    )
  }

  if (asHTML) {
    return (
      <ActionList.Item role="option" {...computedProps}>
        <SanitizedHtml>{value}</SanitizedHtml>
      </ActionList.Item>
    )
  } else {
    return (
      <ActionList.Item role="option" {...computedProps}>
        {value}
      </ActionList.Item>
    )
  }
}

SuggestionsListItem.displayName = 'SuggestionsListItem'
